import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// The change-company modal of a listing, attached to the modal content so the
// footer buttons reach it. Every choice that changes the move plan (listings in
// the move, primary manager, conflict resolutions) reloads the modal with the
// form's current state, so nothing is applied before save. The listings a
// conflict resolution brings along are derived server-side.
export default class extends Controller {
  static targets = ["form", "existingDestination", "newDestination", "partnerCompanyId"]

  refresh() {
    this.reload()
  }

  // Questions first, then the review of what the move does.
  goToStep({ params: { step } }) {
    this.reload({ set: { step } })
  }

  // The replacement select sits inside the "replace" choice and picks it too.
  pickReplacement({ params: { radio } }) {
    document.getElementById(radio).checked = true
    this.reload()
  }

  // Dispatched by the listing search suggestions.
  addListing({ detail: { listingId } }) {
    this.reload({ add: [listingId] })
  }

  removeListing({ params: { id } }) {
    this.reload({ remove: String(id) })
  }

  // A manager kept behind loses access to the moved listings on save.
  keepManager({ params: { id } }) {
    this.reload({ set: { [`manager_resolutions[${id}]`]: "stay" } })
  }

  moveManager({ params: { id } }) {
    this.reload({ unset: [`manager_resolutions[${id}]`] })
  }

  toggleDestination({ target: { value } }) {
    const creating = value === "new"
    this.existingDestinationTarget.classList.toggle("d-none", creating)
    this.newDestinationTarget.classList.toggle("d-none", !creating)
  }

  // Emptying the search drops the company picked from its suggestions.
  clearPartnerCompany({ target: { value } }) {
    if (value === "") this.partnerCompanyIdTarget.value = ""
  }

  reload({ add = [], remove = null, set = {}, unset = [] } = {}) {
    const url = new URL(this.formTarget.dataset.reloadUrl, window.location.origin)
    for (const [name, value] of new FormData(this.formTarget)) {
      if (["authenticity_token", "_method", "utf8", "button"].includes(name)) continue
      if (name === "listing_ids[]" && value === remove) continue
      if (name in set || unset.includes(name)) continue
      url.searchParams.append(name, value)
    }
    Object.entries(set).forEach(([name, value]) => url.searchParams.append(name, value))
    add.forEach((id) => url.searchParams.append("listing_ids[]", id))
    url.searchParams.set("refresh", "true")

    fetch(url, { headers: { Accept: "text/vnd.turbo-stream.html" } })
      .then((response) => response.text())
      .then((html) => Turbo.renderStreamMessage(html))
  }
}
